import { QueryClient } from '@tanstack/react-query';
import { QUERY_STALE_MS } from '../shared/constants/app.constant';
import { isApiError } from '../shared/services/http.service';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: QUERY_STALE_MS,
        refetchOnWindowFocus: true,
        retry: (count, error) =>
          !(isApiError(error) && error.status >= 400 && error.status < 500) && count < 2,
      },
    },
  });
}
